var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    { ref: _vm.dialogRef, attrs: { "md-click-outside-to-close": false } },
    [
      _c("md-dialog-title", [
        _vm._v(_vm._s(_vm.isEdit ? "Edit section" : "Add new section"))
      ]),
      _c("p", { staticClass: "error" }, [_vm._v(_vm._s(_vm.errorMessage))]),
      _c(
        "md-dialog-content",
        [
          _vm.seriesInPlaylist.length > 0
            ? _c(
                "div",
                { staticClass: "radioButtons-section" },
                [
                  _c(
                    "md-checkbox",
                    {
                      staticClass: "md-primary",
                      model: {
                        value: _vm.isSeries,
                        callback: function($$v) {
                          _vm.isSeries = $$v
                        },
                        expression: "isSeries"
                      }
                    },
                    [_vm._v(" Series")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "md-layout",
            { staticClass: "addSection" },
            [
              _c("div", { staticClass: "md-subheading player-size" }, [
                _vm._v("Title")
              ]),
              _c(
                "md-input-container",
                [
                  _c("label", [_vm._v("Title")]),
                  _c("md-input", {
                    attrs: { maxlength: 50, disabled: _vm.titleDisabled },
                    model: {
                      value: _vm.title,
                      callback: function($$v) {
                        _vm.title = $$v
                      },
                      expression: "title"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "md-subheading player-size" }, [
                _vm._v(_vm._s(!_vm.isSeries ? "Associated tags" : "Series"))
              ]),
              !_vm.isSeries
                ? _c("md-chips", {
                    attrs: {
                      "md-max": 15,
                      "md-input-placeholder": "Add a tag..."
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(chip) {
                            return [_c("span", [_vm._v(_vm._s(chip.value))])]
                          }
                        }
                      ],
                      null,
                      false,
                      3226392169
                    ),
                    model: {
                      value: _vm.associatedTags,
                      callback: function($$v) {
                        _vm.associatedTags = $$v
                      },
                      expression: "associatedTags"
                    }
                  })
                : _c(
                    "md-input-container",
                    [
                      _vm.seriesInPlaylist.length > 0
                        ? _c(
                            "md-select",
                            {
                              attrs: {
                                multiple: "multiple",
                                placeholder: "Select series"
                              },
                              model: {
                                value: _vm.selectedSeries,
                                callback: function($$v) {
                                  _vm.selectedSeries = $$v
                                },
                                expression: "selectedSeries"
                              }
                            },
                            _vm._l(_vm.seriesInPlaylist, function(series) {
                              return _c(
                                "md-option",
                                {
                                  key: series._id,
                                  attrs: { value: series._id }
                                },
                                [_vm._v(_vm._s(series.name))]
                              )
                            }),
                            1
                          )
                        : _c("md-input", {
                            attrs: {
                              disabled: "disabled",
                              placeholder: "No series available"
                            }
                          })
                    ],
                    1
                  )
            ],
            1
          ),
          _c("div", { staticClass: "md-subheading player-size" }, [
            _vm._v("Items")
          ]),
          _vm.sectionItems.length > 0
            ? _c(
                "div",
                { staticClass: "section-items" },
                [
                  _c(
                    "SlickList",
                    {
                      staticClass:
                        "section-items-list videoContainer md-list custom-list md-triple-line",
                      attrs: {
                        lockAxis: "y",
                        pressDelay: 100,
                        helperClass: "dragging-helper",
                        useWindowAsScrollContainer: true
                      },
                      on: { input: _vm.onItemsSorted },
                      model: {
                        value: _vm.sectionItems,
                        callback: function($$v) {
                          _vm.sectionItems = $$v
                        },
                        expression: "sectionItems"
                      }
                    },
                    _vm._l(_vm.sectionItems, function(item, index) {
                      return _c(
                        "SlickItem",
                        {
                          key: item._id,
                          staticClass:
                            "section-item md-list-item sortable-item",
                          attrs: { index: index }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-list-item-container" },
                            [
                              !_vm.isSeries
                                ? _c("md-avatar", [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.getItemPoster(item),
                                        alt: item.name
                                      }
                                    })
                                  ])
                                : _c("md-avatar", [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.getItemPoster(item),
                                        alt: item.name
                                      }
                                    })
                                  ]),
                              _c("div", [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                !_vm.isSeries &&
                                (item.duration || item.videoDuration)
                                  ? _c("span", { staticClass: "detail" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDuration(
                                            item.duration || item.videoDuration
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.isSeries && item.credit
                                  ? _c("span", { staticClass: "detail" }, [
                                      _vm._v(_vm._s(item.credit))
                                    ])
                                  : _vm._e(),
                                _vm.isSeries
                                  ? _c("span", { staticClass: "detail" }, [
                                      _vm._v("Series")
                                    ])
                                  : _vm._e(),
                                !_vm.isSeries
                                  ? _c(
                                      "div",
                                      { staticClass: "tagsContainer" },
                                      [
                                        item.serie
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "tag sect-series"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.serie.name
                                                      ? item.serie.name
                                                      : "Series"
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        item.tags && item.tags.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "tagsContainer" },
                                              _vm._l(item.tags, function(tag) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: tag,
                                                    staticClass: "tag"
                                                  },
                                                  [_vm._v(_vm._s(tag))]
                                                )
                                              }),
                                              0
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _c(
                                "div",
                                { staticClass: "btn-container" },
                                [
                                  !_vm.isSeries
                                    ? _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-icon-button md-raised",
                                          attrs: { id: "btnInfo" },
                                          nativeOn: {
                                            mouseover: function($event) {
                                              return _vm.showInfo(index, true)
                                            },
                                            mouseleave: function($event) {
                                              return _vm.showInfo(index, false)
                                            }
                                          }
                                        },
                                        [
                                          _c("md-icon", {
                                            staticClass: "md-icon",
                                            attrs: {
                                              "md-iconset": "fa fa-info-circle"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-icon-button md-warn md-list-action",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeSectionItem(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "md-icon",
                                        attrs: {
                                          "md-iconset": "fa fa-trash-alt"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  !_vm.isSeries && _vm.isShowInfo === index
                                    ? _c("div", { staticClass: "info-video" }, [
                                        item.serie
                                          ? _c(
                                              "p",
                                              { staticClass: "text-item" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Series: ")
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.serie.name
                                                        ? item.serie.name
                                                        : "Series"
                                                    )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        item.tags && item.tags.length > 0
                                          ? _c(
                                              "p",
                                              { staticClass: "text-item" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Tags: ")
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.tags.join(", "))
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("md-divider")
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _c("div", { staticClass: "no-items" }, [
                _vm._v("No items to show")
              ])
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary md-raised",
              on: {
                click: function($event) {
                  return _vm.addSection()
                }
              }
            },
            [_vm._v(_vm._s(_vm.isEdit ? "Save" : "Add"))]
          ),
          _c(
            "md-button",
            {
              staticClass: "cancel-btn md-raised",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_vm._v("Cancel")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58ca90da", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58ca90da","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/EditOrNewSection.vue
// module id = 814
// module chunks = 0